import {  useState } from "react";
import { CONSTANTS_STRINGS } from "../../Utils/Constant";


function FAQS() {
  const qa = CONSTANTS_STRINGS.faqs.items;
  const [openIndex, setOpenIndex] = useState(null);



  return (
    <div className="bg-gray-100 w-full h-auto pt-10 pb-30">
      <div className="grid h-auto md:grid-cols-2 gap-10">
        {/* Left Content */}
        <div className="px-10 md:self-start md:sticky top-10">
          <p className="text-xs bg-white text-green-600 px-4 py-1 mb-5 inline-block">
            {CONSTANTS_STRINGS.faqs.faq}
          </p>
          <p className="md:text-6xl text-2xl font-semibold mb-4">
            {CONSTANTS_STRINGS.faqs.t1}
          </p>
          <p className="text-gray-600 mb-6">{CONSTANTS_STRINGS.faqs.t2}</p>
          <button className="bg-[#090933] text-white md:px-5 px-3 md:py-3 py-2 mb-5 md:mb-0 rounded-full transition-all hover:bg-[#4bab6a]">
            {CONSTANTS_STRINGS.faqs.button}
          </button>
        </div>

        {/* Right Side */}
        <div className="px-10 py-10" >
          { 
            qa.map((faq, index) => (
              <div key={index} className="mb-4">
                <div
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                  className="cursor-pointer flex justify-between items-center py-2"
                >
                  <h2 className="text-xl text-gray-800">{faq.question}</h2>
                  <span>{openIndex === index ? "-" : "+"}</span>
                </div>
                {openIndex === index && (
                  <p className="text-gray-600 py-2">{faq.answer}</p>
                )}
                <hr />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

export default FAQS;
